import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getMyPathwaysAsync } from '../../../Services/DashboardService';
import Card from '../../../Shared/Components/Card/Card';
import Header from '../../../Shared/Components/Header/Header';
import Table from '../../../Shared/Components/Table';

const LearnerLearningPathways = () => {
    const [pathways, setPathways] = useState([]);

    useEffect(() => {
        getPathways();
    }, [])

    const getPathways = async () => {
        let response = await getMyPathwaysAsync();
        setPathways(response.learningPathways);
    }

    const headings = () => {
        return (<>
            <th>Name</th>
            <th>Description</th>
            <th></th>
        </>)
    }

    const rowData = () => {
        return (
            <>
                {pathways.length > 0 ?
                    pathways.map(
                        (p, i) =>
                            <tr key={i}>
                                <td>
                                    {p.name}
                                </td>
                                <td>
                                    {p.description}
                                </td>
                                <td>
                                    <Link to={`/learning-pathway/${p.id}`} className="btn btn-sm btn-outline-primary action-button float-right mr-3">
                                        View
                                    </Link>
                                </td>
                            </tr>
                    )
                    :
                    <tr>
                        <td className="no-data" colSpan="4">
                            No learning pathways to currently display
                        </td>
                    </tr>
                }
            </>
        )
    }

    return (
        <>
            <Header heading="Learning Pathways" subheading="Please complete all learning pathways displayed below" icon="bar-chart" />
            <div className="container-fluid content">
                <div className="row">
                    <div className="col-12">
                        <Card title="My Pathways" >
                            <Table headings={headings} rowData={rowData} />
                        </Card>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LearnerLearningPathways;